import React from "react";
import { Skeleton } from "antd";
import LinearDivider from "../../../components/LinearDividers";

function MarkerInfoAbout({ title = "", loading = false, description = "" }) {
  return (
    <div className="about">
      <div className="title">
        <Skeleton loading={loading} paragraph={{ rows: 1 }} title={false}>
          {title}
        </Skeleton>
      </div>
      <LinearDivider width={"50%"} />
      <div className="description">
        <Skeleton loading={loading} title paragraph={false}>
          {description}
        </Skeleton>
      </div>
    </div>
  );
}

export default MarkerInfoAbout;
